import { render, staticRenderFns } from "./branchTab.vue?vue&type=template&id=0827090c&scoped=true&"
import script from "./branchTab.vue?vue&type=script&lang=js&"
export * from "./branchTab.vue?vue&type=script&lang=js&"
import style0 from "./branchTab.vue?vue&type=style&index=0&id=0827090c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827090c",
  null
  
)

export default component.exports